import React from "react";

import { Button } from "../../Button";
import { ButtonTypes, TextTypes, TextColors } from "../../constants";
import { clickAnalytics } from "../../../components/Common/InsuranceEligibility/signup_analytics";
import { SUPPORT_NUMBER, SUPPORT_NUMBER_HREF } from "../../../constants/aptihealth";
import { Text } from "../../Text";

import "./styles.scss";

// Relates to: Self Signup

export const VerifyInsurancePending = ({ insuranceName, onClick, step, title }) => {
  return (
    <div className="apti-VerifyInsurance">
      <Text color={TextColors.green} type={TextTypes.heading1}>
        {title}
      </Text>
      <Text className="details">
        <>
          <div>We aren’t able to check your insurance coverage right now.</div>
          <div>
            Please contact{" "}
            <a
              className="green bold link"
              href="mailto:support@aptihealth.com"
              onClick={() => clickAnalytics("self_signup", "pending", "email")}
            >
              support@aptihealth.com
            </a>{" "}
            or{" "}
            <a
              className="green bold link"
              href={SUPPORT_NUMBER_HREF}
              onClick={() => clickAnalytics("self_signup", "pending", "call")}
            >
              {SUPPORT_NUMBER}
            </a>{" "}
            before your first appointment to prevent billing issues.
          </div>
        </>
      </Text>
      <Button className={ButtonTypes.primary} onClick={onClick}>
        Okay
      </Button>
    </div>
  );
};

VerifyInsurancePending.defaultProps = {
  insuranceName: "",
  onClick: () => {},
  title: "",
};
